import React from "react";
import { NpsData, NumberScaleData } from "../../../types/admin";
import {Col, ProgressBar, Row, Table} from "react-bootstrap";
import {ADMIN_LANG} from "../../../settings";

type Props = {
    optionsData: NumberScaleData[];
    npsScale: NpsData | undefined;
}

const NumberScaleTable = ({ optionsData, npsScale }: Props) => {
    if (npsScale) {
    const { promoters, passives, detractors } = npsScale;
    const totalResponses = promoters + passives + detractors;

    const renderNpsRow = (label: string, count: number, percentage: number, variant: string) => (
        <Row className="mb-4">
            <Col xs={4}>{label}</Col>
            <Col xs={3}>{`${count} (${percentage.toFixed(2)}%)`}</Col>
            <Col xs={5}>
                <ProgressBar now={percentage} variant={variant} />
            </Col>
        </Row>
    );

    return (
        <Col xs={12} lg={6}>
            <div className='admin-card'>
                <div className='mb-4'>
                    <p>{ADMIN_LANG.total}: <span className="fs-2">{totalResponses}</span></p>
                    <ProgressBar>
                        <ProgressBar variant="danger" now={(detractors / totalResponses) * 100} key={1}/>
                        <ProgressBar variant="warning" now={(passives / totalResponses) * 100} key={2}/>
                        <ProgressBar variant="success" now={(promoters / totalResponses) * 100} key={3}/>
                    </ProgressBar>
                </div>
                <hr className='mb-4'></hr>
                <div>
                    {renderNpsRow(ADMIN_LANG.promoters, promoters, (promoters / totalResponses) * 100, "success")}
                    <hr className='mb-4'></hr>
                    {renderNpsRow(ADMIN_LANG.passives, passives, (passives / totalResponses) * 100, "warning")}
                    <hr className='mb-4'></hr>
                    {renderNpsRow(ADMIN_LANG.detractors, detractors, (detractors / totalResponses) * 100, "danger")}
                </div>
            </div>
        </Col>
    );
    }

    return (
        <Col xs={12} lg={6}>
            <div className='admin-card'>
                <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>{ADMIN_LANG.rating}</th>
                        <th>{ADMIN_LANG.label}</th>
                        <th>{ADMIN_LANG.selections}</th>
                        <th>{ADMIN_LANG.percentage}</th>
                    </tr>
                </thead>
                <tbody>
                    {optionsData.map((option, index) => (
                        <tr key={index}>
                            <td>{option.rating}</td>
                            <td>{option.name}</td>
                            <td>{option.selections}</td>
                            <td>{option.percentage}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            </div>
        </Col>
    );
}

export default NumberScaleTable;